import { render, staticRenderFns } from "./profileInfo.vue?vue&type=template&id=81234366&scoped=true&"
import script from "./profileInfo.vue?vue&type=script&lang=js&"
export * from "./profileInfo.vue?vue&type=script&lang=js&"
import style0 from "./profileInfo.vue?vue&type=style&index=0&id=81234366&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81234366",
  null
  
)

export default component.exports